/**
 * Comment une ressource réelle se nomme à l'écran.
 *
 * Deux écrans posent la même question — le plan de charge, quand il propose qui affecter, et le
 * planning des ressources, quand il en dresse la liste. **Une machine ne peut pas s'appeler
 * autrement d'un écran à l'autre** : le responsable la reconnaît par ce libellé, et deux
 * fabrications séparées finiraient par n'en écrire qu'une des deux à jour.
 */
import type { Materiel, Salarie } from "./api";

/**
 * Comment une machine se nomme dans une liste.
 *
 * *Demande de Chris, 15/08/2026 : « mettre les champs du référentiel code erp, type,
 * description, immat ».* Les quatre, dans cet ordre — le code ERP d'abord parce que c'est lui
 * qui désigne, et parce qu'une liste triée par code se parcourt à l'œil.
 *
 * Les champs vides **sautent** au lieu de laisser un séparateur orphelin : 72 machines du parc
 * n'ont pas d'immatriculation, et « CHARGEUSE · · » se lirait comme une fiche incomplète alors
 * que c'est un engin non routier.
 */
export function designerMateriel(materiel: Materiel): string {
  const morceaux = [materiel.type, materiel.description, materiel.immatriculation].filter(
    (m): m is string => m !== null && m !== "",
  );
  return morceaux.length === 0 ? materiel.codeErp : `${materiel.codeErp} · ${morceaux.join(" · ")}`;
}

/**
 * Comment une personne se nomme dans une liste.
 *
 * Le nom avant le prénom, comme le référentiel maître l'écrit : c'est par le nom qu'on cherche
 * quelqu'un dans une liste de cent trente. Le poste suit quand il est renseigné — il distingue
 * deux homonymes, et le référentiel en compte.
 */
export function designerSalarie(salarie: Salarie): string {
  const nom = `${salarie.nom} ${salarie.prenom}`.trim();
  return salarie.poste === null || salarie.poste === "" ? nom : `${nom} · ${salarie.poste}`;
}
